import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import USChloroplethMap from "./components/USChloroplethMap";
import WorldChloroplethMap from "./components/WorldChloroplethMap";
import { Route, Link, BrowserRouter as Router, Switch } from "react-router-dom";
import './styles.scss';
import SocialMediaButtons from './components/SocialMediaButtons';
import Datamap from "datamaps";
// import d3 from "d3";
import { Helmet } from 'react-helmet';
import { tagToColor } from "./maps";
import RadioControlsForMap from './components/RadioControlsForMap';
import RadioBasedCustomMap from './components/RadioBasedCustomMap';
// import ReactGA from 'react-ga';

// import Loader from 'react-loader-spinner'
// import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"


// const loader = <Loader
//   type="Oval"
//   color="#343a40"
//   height={100}
//   width={100}
//   timeout={3000} //3 secs

// />;

class Nav extends Component {
  render() {
    return (
      // <Router>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <a className="navbar-brand" href="#">
          Name
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>
        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <ul className="navbar-nav">
            <li className="nav-item active">
              <a className="nav-link" href="#">
                Home <span className="sr-only">(current)</span>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#">
                Link #1
              </a>
            </li>
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdownMenuLink"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Maps
              </a>
              <div
                className="dropdown-menu"
                aria-labelledby="navbarDropdownMenuLink"
              >
                {/* <a className="dropdown-item" href="#">
                  Action
                </a> */}
                <Link className="dropdown-item" to="/us-median-incomes">
                  US Median Incomes
                </Link>
                <Link className="dropdown-item" to="/us-population">
                  US Population
                </Link>
                {/* <a className="dropdown-item" href="#">
                  Another action
                </a> */}
                {/* <a className="dropdown-item" href="#">
                    Something else here
                  </a> */}
              </div>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
}

class TimeSeriesChloropleth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true
    };
    this.onChange = this.onChange.bind(this);
  }
  componentDidMount() {
    fetch(this.props.mapData.dataSource)
      .then(response => response.json())
      .then(data => {
        // console.log(data);
        const yearsStr = Object.keys(data);
        const years = yearsStr.map(item => parseInt(item, 10));
        years.sort(function(a, b) {
          return a - b;
        });

        let sliderIndices = {};
        let sliderIndicesToYear = {};
        years.forEach((y, i) => {
          // console.log(y,i);
          sliderIndices[i] = y;
          sliderIndicesToYear[i] = y;
        });
        this.setState({
          isLoading: false,
          data: data,
          currentData: data[sliderIndicesToYear[0]],
          sliderIndices: sliderIndices,
          currentSlider: 0,
          sliderIndicesToYear: sliderIndicesToYear,
          sliderMin: 0,
          sliderMax: years.length - 1
        });
      });
  }
  onChange(event) {
    this.setState({
      currentSlider: event.target.value,
      currentData: this.state.data[
        this.state.sliderIndicesToYear[event.target.value]
      ]
    });
  }

  render() {
    if (this.state.isLoading) {
      return (
        // <div className="loadingOval">
        //   Loading...
        // </div>
        <div className="text-center">
          <div className="spinner-border btLoadingOval" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
        );
      // return <p>Loading...</p>;
    }
    else{
      let map = null;
      switch(this.props.mapData.scope){
        case "world":
          map = <WorldChloroplethMap
            data={this.state.currentData}
            key={this.state.currentSlider}
            stats={this.props.stats}
          />;
          break;
        case "usa":
          map = <USChloroplethMap
            data={this.state.currentData}
            key={this.state.currentSlider}
            stats={this.props.stats}
          />;
          break;
      }
      return (
        <div className="mapContainer container-fluid">
          {this.props.helmetComp}
          <div className="mapTitle">
            <h3 className="mapHeading">
              {this.props.mapTitle}
            </h3>
          </div>
          {/* <div className="row"> */}
          <div className="mapPlusControls">
            {/* <div className="col-md-9 col-sm-12 col-xs-12"> */}
            <div className="mapComponent">
              {map}
          </div>
            
            {/* <div className={"col-md-3 col-sm-12 col-xs-12 controlsPane" + (this.props.mapData.scope==="world"?" controlsPaneWorld":"")}> */}
            <div className={"controlsPane" + (this.props.mapData.scope === "world" ? " controlsPaneWorld" : "")}>
                <div className="yearsSlider">
                {this.props.mapData.yearRanges
                ?
                <div>
                  <p className="lead">Move the slider to change year range</p>
                  <p className="lead">Current Range:{" "}
                    <span className="year-highlight">
                        {this.state.sliderIndicesToYear[this.state.currentSlider]} -  {this.state.sliderIndicesToYear[this.state.currentSlider]+this.props.mapData.yearRanges.range}
                    </span></p>
                    </div>
                    :
                    <div>
                      <p className="lead">Move the slider to change year</p>
                    <p className="lead">Current Year:{" "}
                      <span className="year-highlight">
                        {this.state.sliderIndicesToYear[this.state.currentSlider]}
                      </span></p>
                      </div>}
                <input
                  className="slider"
                  type="range"
                  id="inputSlider"
                  min={this.state.sliderMin}
                  max={this.state.sliderMax}
                  value={this.state.currentSlider}
                  step="1"
                  onChange={this.onChange}
                />
              </div>
              <div className="mapCardTagsOnMapPage">
                {this.props.mapData["tags"].map((tag, i) => (
                  <span className="badge badge-dark mapTag" style={{ backgroundColor: tagToColor[tag] }}>{tag}</span>
                ))}
              </div>
              <div className="dataSourceAndCitations">
                {this.props.mapData.citationSource === "" ? null : <p><a href={this.props.mapData.citationSource} target="_blank" rel="noopener noreferrer">data source</a></p>}
              </div>
              <div className="otherInfo">
                <SocialMediaButtons shareTitle={this.props.mapTitle} shareUrl={window.location.href} />
              </div>
              </div>
            
            </div>
        </div>
      );
    }
  }
}



class RadioBasedUSChloropleth extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    // console.log("mounted");
    // this.setState({ isLoading: true });
    fetch(this.props.mapData.dataSource)
      .then(response => response.json())
      .then(data => {
        // console.log(data);
        const radioKeys = Object.keys(data);
        // console.log(keys);
        this.setState({
          isLoading: false,
          data: data,
          currentData: data[radioKeys[0]],
          radioKeys: radioKeys,
          chosenRadio: radioKeys[0],
        });
      });
  }
  handleChange(value) {
    // console.log(value);
    this.setState({
      chosenRadio: value,
      currentData: this.state.data[value]
    });
  }

  render() {
    if (this.state.isLoading) {
      return (
      // <div className="loadingOval">
      //   Loading...
      //   </div>
        <div className="text-center">
          <div className="spinner-border btLoadingOval" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
        );
    }
    return (
      <div className="mapContainer container-fluid">
        {this.props.helmetComp}
        <div className="mapTitle">
          <h3 className="mapHeading">
            {this.props.mapTitle}
          </h3>
        </div>
        {/* <div className="row"> */}
          {/* <div className="col-md-9 col-sm-12 col-xs-12"> */}
        <div className="mapPlusControls">
          <div className="mapComponent">
        <USChloroplethMap
          data={this.state.currentData}
          key={this.state.chosenRadio}
          stats={this.props.stats[this.state.chosenRadio]}
        />
          </div>

          {/* <div className="col-md-3 col-sm-12 col-xs-12 controlsPane"> */}
          <div className="controlsPane">
            <div className="mapRadios">
              <RadioControlsForMap radioKeysPreset={this.props.mapData.radioKeysPreset ? this.props.mapData.radioKeysPreset : null} handleChange={this.handleChange} radioKeys={this.state.radioKeys} textAboveMapControls={this.props.mapData.textAboveMapControls|| "Choose a parameter"}/>
            </div>
            <div className="mapCardTagsOnMapPage">
              {this.props.mapData["tags"].map((tag, i) => (
                <span className="badge badge-dark mapTag" style={{ backgroundColor: tagToColor[tag] }}>{tag}</span>
              ))}
            </div>
            <div className="dataSourceAndCitations">
              {this.props.mapData.citationSource === "" ? null : <p><a href={this.props.mapData.citationSource} target="_blank" rel="noopener noreferrer">data source</a></p>}
            </div>
            <div className="otherInfo">
            <SocialMediaButtons shareTitle={this.props.mapTitle} shareUrl={window.location.href} />
          </div>
        </div>
        </div>
      </div>
    );
  }
}
class RadioBasedWorldChloropleth extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    // console.log("mounted");
    // this.setState({ isLoading: true });
    fetch(this.props.mapData.dataSource)
      .then(response => response.json())
      .then(data => {
        // console.log(data);
        const radioKeys = Object.keys(data);
        // console.log(keys);
        this.setState({
          isLoading: false,
          data: data,
          currentData: data[radioKeys[0]],
          radioKeys: radioKeys,
          chosenRadio: radioKeys[0],
        });
      });
  }
  handleChange(value) {
    // console.log(value);
    this.setState({
      chosenRadio: value,
      currentData: this.state.data[value]
    });
  }

  render() {
    if (this.state.isLoading) {
      return (
      // <div className="loadingOval">
      //   Loading...
      //   </div>
        <div className="text-center">
          <div className="spinner-border btLoadingOval" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
        );
    }
    return (
      <div className="mapContainer container-fluid">
        {this.props.helmetComp}
        <div className="mapTitle">
          <h3 className="mapHeading">
            {this.props.mapTitle}
          </h3>
        </div>
        {/* <div className="row">
          <div className="col-md-9 col-sm-12 col-xs-12"> */}
        <div className="mapPlusControls">
          <div className="mapComponent">
            <WorldChloroplethMap
              data={this.state.currentData}
              key={this.state.chosenRadio}
              stats={this.props.stats[this.state.chosenRadio]}
            />
          </div>

          {/* <div className="col-md-3 col-sm-12 col-xs-12 controlsPane controlsPaneWorld"> */}
            <div className="controlsPane controlsPaneWorld">
            <div className="mapRadios">
              <RadioControlsForMap handleChange={this.handleChange} radioKeys={this.state.radioKeys} radioKeysPreset={this.props.mapData.radioKeysPreset ? this.props.mapData.radioKeysPreset:null} textAboveMapControls={this.props.mapData.textAboveMapControls || "Choose a parameter"} />
            </div>
            <div className="mapCardTagsOnMapPage">
              {this.props.mapData["tags"].map((tag, i) => (
                <span className="badge badge-dark mapTag" style={{ backgroundColor: tagToColor[tag] }}>{tag}</span>
              ))}
            </div>
            <div className="dataSourceAndCitations">
              {this.props.mapData.citationSource === "" ? null : <p><a href={this.props.mapData.citationSource} target="_blank" rel="noopener noreferrer">data source</a></p>}
            </div>
            <div className="otherInfo">
              <SocialMediaButtons shareTitle={this.props.mapTitle} shareUrl={window.location.href} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class RadioBasedUSChloroplethWithTimeSeriesData extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true
    };
    this.handleChangeForRadio = this.handleChangeForRadio.bind(this);
    this.handleChangeForSlider = this.handleChangeForSlider.bind(this);
  }
  componentDidMount() {
    // console.log("mounted");
    // this.setState({ isLoading: true });
    fetch(this.props.mapData.dataSource)
      .then(response => response.json())
      .then(data => {
        // console.log(data);
        const radioKeys = Object.keys(data);

        const yearsStr = Object.keys(data[radioKeys[0]]);
        const years = yearsStr.map(item => parseInt(item, 10));
        years.sort(function (a, b) {
          return a - b;
        });

        let sliderIndices = {};
        let sliderIndicesToYear = {};
        years.forEach((y, i) => {
          // console.log(y,i);
          sliderIndices[i] = y;
          sliderIndicesToYear[i] = y;
        });
        // console.log(keys);
        this.setState({
          isLoading: false,
          data: data,
          currentData: data[radioKeys[0]][sliderIndicesToYear[0]],
          radioKeys: radioKeys,
          chosenRadio: radioKeys[0],
          sliderIndices: sliderIndices,
          currentSlider: 0,
          sliderIndicesToYear: sliderIndicesToYear,
          sliderMin: 0,
          sliderMax: years.length - 1
        });
      });
  }
  handleChangeForRadio(value) {
    console.log(value);
    this.setState({
      chosenRadio: value,
      currentData: this.state.data[value][
        this.state.sliderIndicesToYear[this.state.currentSlider]]
    });
  }
  handleChangeForSlider(event) {
    console.log(this.state.data[this.state.chosenRadio][this.state.sliderIndicesToYear[event.target.value]])
    this.setState({
      currentSlider: event.target.value,
      currentData: this.state.data[this.state.chosenRadio][this.state.sliderIndicesToYear[event.target.value]]
    });
  }

  render() {
    if (this.state.isLoading) {
      return (
      // <div className="loadingOval">
      //   Loading...
      //   </div>
        <div className="text-center">
          <div className="spinner-border btLoadingOval" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
        );
    }
    return (
      <div className="mapContainer container-fluid">
        {this.props.helmetComp}
        <div className="mapTitle">
          <h3 className="mapHeading">
            {this.props.mapTitle}
          </h3>
        </div>
        {/* <div className="row">
          <div className="col-md-9 col-sm-12 col-xs-12"> */}
        <div className="mapPlusControls">
          <div className="mapComponent">
        <USChloroplethMap
          data={this.state.currentData}
          key={`${this.state.chosenRadio}-${this.state.currentSlider}`}
          stats={this.props.stats[this.state.chosenRadio]}
        />
          </div>

          {/* <div className="col-md-3 col-sm-12 col-xs-12 controlsPane"> */}
            <div className="controlsPane">
            <div className="mapRadios">
              <RadioControlsForMap handleChange={this.handleChangeForRadio} radioKeys={this.state.radioKeys} textAboveMapControls={this.props.mapData.textAboveMapControls || "Choose a parameter"} />
            </div>
            <div className="yearsSlider">
              <p className="lead">Move the slider to change year</p>
              <p className="lead">Current Year:{" "}
                <span className="year-highlight">
                  {this.state.sliderIndicesToYear[this.state.currentSlider]}
                </span></p>
              <input
                className="slider"
                type="range"
                id="inputSlider"
                min={this.state.sliderMin}
                max={this.state.sliderMax}
                value={this.state.currentSlider}
                step="1"
                onChange={this.handleChangeForSlider}
              />
            </div>
            <div className="mapCardTagsOnMapPage">
              {this.props.mapData["tags"].map((tag, i) => (
                <span className="badge badge-dark mapTag" style={{ backgroundColor: tagToColor[tag] }}>{tag}</span>
              ))}
            </div>
            <div className="dataSourceAndCitations">
              {this.props.mapData.citationSources.length == 1 ? (<p><a href={this.props.mapData.citationSources[0]} target="_blank" rel="noopener noreferrer">data source</a></p>):(
              <p>Data Sources: 
              {this.props.mapData.citationSources.map((source, i)=>{
                return <a href={source} target="_blank" rel="noopener noreferrer"> {`${i+1}`}</a>
              })}
              </p>
              )
            }
              {/* {this.props.mapData.citationSource === "" ? null : <p><a href={this.props.mapData.citationSource} target="_blank" rel="noopener noreferrer">data source</a></p>} */}
            </div>
            <div className="otherInfo">
            <SocialMediaButtons shareTitle={this.props.mapTitle} shareUrl={window.location.href} />
          </div>
        </div>
      </div>
      </div>
    );
  }
}

class RadioBasedUSChloroplethWithRadioControls extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true
    };
    this.handleChangeForMainRadio = this.handleChangeForMainRadio.bind(this);
    this.handleChangeForSecondaryRadio = this.handleChangeForSecondaryRadio.bind(this);
  }
  componentDidMount() {
    // console.log("mounted");
    // this.setState({ isLoading: true });
    fetch(this.props.mapData.dataSource)
      .then(response => response.json())
      .then(data => {
        // console.log(data);
        const mainRadioKeys = Object.keys(data);

        const secondaryRadioKeys = Object.keys(data[mainRadioKeys[0]]);

        this.setState({
          isLoading: false,
          data: data,
          currentData: data[mainRadioKeys[0]][secondaryRadioKeys[0]],
          mainRadioKeys: mainRadioKeys,
          secondaryRadioKeys: secondaryRadioKeys,
          chosenMainRadio: mainRadioKeys[0],
          chosenSecondaryRadio: secondaryRadioKeys[0],
        });
      });
  }
  handleChangeForMainRadio(value) {
    console.log(value);
    this.setState({
      chosenMainRadio: value,
      currentData: this.state.data[value][
        this.state.chosenSecondaryRadio]
    });
  }
  handleChangeForSecondaryRadio(value) {
    console.log(value);
    this.setState({
      chosenSecondaryRadio: value,
      currentData: this.state.data[this.state.chosenMainRadio][
        value]
    });
  }

  render() {
    if (this.state.isLoading) {
      return (
      // <div className="loadingOval">
      //   Loading...
      //   </div>
        <div className="text-center">
          <div className="spinner-border btLoadingOval" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
        );
    }
    return (
      <div className="mapContainer container-fluid">
        {this.props.helmetComp}
        <div className="mapTitle">
          <h3 className="mapHeading">
            {this.props.mapTitle}
          </h3>
        </div>
        {/* <div className="row">
          <div className="col-md-9 col-sm-12 col-xs-12"> */}
        <div className="mapPlusControls">
          <div className="mapComponent">
            <USChloroplethMap
              data={this.state.currentData}
              key={`${this.state.chosenMainRadio}-${this.state.chosenSecondaryRadio}`}
              stats={this.props.stats[this.state.chosenMainRadio][this.state.chosenSecondaryRadio]}
            />
          </div>

          {/* <div className="col-md-3 col-sm-12 col-xs-12 controlsPane"> */}
          <div className="controlsPane">
            <div className="mapRadios mainRadioControls">
              <RadioControlsForMap handleChange={this.handleChangeForMainRadio} radioKeys={this.state.mainRadioKeys} textAboveMapControls={this.props.mapData.textAboveMainRadioControls || "Choose a parameter"} />
            </div>
            <div className="mapRadios secondaryRadioControls">
              <RadioControlsForMap handleChange={this.handleChangeForSecondaryRadio} radioKeys={this.state.secondaryRadioKeys} textAboveMapControls={this.props.mapData.textAboveSecondaryRadioControls || "Choose a parameter"} />
            </div>
            <div className="mapCardTagsOnMapPage">
              {this.props.mapData["tags"].map((tag, i) => (
                <span className="badge badge-dark mapTag" style={{ backgroundColor: tagToColor[tag] }}>{tag}</span>
              ))}
            </div>
            <div className="dataSourceAndCitations">
              {this.props.mapData.citationSources.length == 1 ? (<p><a href={this.props.mapData.citationSources[0]} target="_blank" rel="noopener noreferrer">data source</a></p>) : (
                <p>Data Sources:
              {this.props.mapData.citationSources.map((source, i) => {
                  return <a href={source} target="_blank" rel="noopener noreferrer"> {`${i + 1}`}</a>
                })}
                </p>
              )
              }
              {/* {this.props.mapData.citationSource === "" ? null : <p><a href={this.props.mapData.citationSource} target="_blank" rel="noopener noreferrer">data source</a></p>} */}
            </div>
            <div className="otherInfo">
              <SocialMediaButtons shareTitle={this.props.mapTitle} shareUrl={window.location.href} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}


// class USChloropleth2 extends Component {
//   constructor(props){
//     super(props);
//     this.state = {
//       isLoading: true
//     };
//     this.handleChange = this.handleChange.bind(this);
//   }
  
//   componentDidMount() {
//     fetch(this.props.mapData.dataSource)
//       .then(response => response.json())
//       .then(data => {
//         // console.log(data);
//         const radioKeys = Object.keys(data);
//         // console.log(keys);
//         this.setState({
//           isLoading: false,
//           data: data,
//           currentData: data[radioKeys[0]],
//           radioKeys: radioKeys,
//           chosenRadio: radioKeys[0],
//         });
//       });
//     }
//   handleChange(value) {
//     // console.log(value);

//     let dataset = {};
//     let toolTipText = this.props.stats.toolTipText;
//     let toolTipTextAfter = this.props.stats.toolTipTextAfter ? this.props.stats.toolTipTextAfter : "";

//     let paletteScale = d3.scale
//       .linear()
//       .domain([this.props.stats.min, this.props.stats.max])
//       .range([this.props.stats.colorMin, this.props.stats.colorMax]);

//     for (let item in this.props.data) {
//       if (this.props.data[item]) {
//         dataset[item] = {
//           numberOfThings: this.props.data[item],
//           fillColor: paletteScale(this.props.data[item])
//         };
//       }
//     }

//     let map = new Datamap({
//       element: document.getElementById("cloropleth_map"),
//       projection: "mercator",
//       scope: "usa",
//       geographyConfig: {
//         popupOnHover: true,
//         highlightOnHover: true,
//         borderColor: "#444",
//         highlightBorderWidth: 3,
//         borderWidth: 0.75,

//         popupTemplate: function (geo, data) {
//           if (!data) {
//             return;
//           }
//           return [
//             '<div class="hoverinfo">',
//             "<strong>",
//             geo.properties.name,
//             "</strong>",
//             `<br>${toolTipText}<strong>`,
//             data.numberOfThings.toLocaleString(),
//             "</strong>",
//             toolTipTextAfter,
//             "</div>"
//           ].join("");
//         }
//       },
//       fills: {
//         HIGH: "#afafaf",
//         LOW: "#123456",
//         MEDIUM: "blue",
//         UNKNOWN: "rgb(0,0,0)",
//         defaultFill: "#eee"
//       },
//       data: dataset
//     });
//     this.setState({
//       chosenRadio: value,
//       currentData: this.state.data[value]
//     });
//   }
//   render() {
//     if (this.state.isLoading) {
//       return (<div className="loadingOval">
//         Loading...
//         </div>);
//     }

//     return <div id="cloropleth_map" />;
//   }
// }


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appName: "Awesome Maps",
      // currentMap: "USMedianIncomes"
      currentMap: this.props.currentMap || "USMedianIncomes"
    };
  }
  render() {
    const helmetComp = <Helmet
      title={`${this.props.mapData.title} - Handy Maps`}
      meta={[
        {
          name: "description",
          property: "og:description",
          content: `Explore ${this.props.mapData.title}`
        },
        { property: "og:title", content: `${this.props.mapData.title} - Handy Maps` },
        { property: "twitter:title", content: `${this.props.mapData.title} - Handy Maps` },
        { property: "twitter:description", content: `Explore ${this.props.mapData.title}` }
      ]}
    />
    // ReactGA.pageview(window.location.pathname + window.location.search);
    switch(this.props.mapData.type){
      case "time-series-chloropleth":
        return (
          <TimeSeriesChloropleth
            mapData={this.props.mapData}
            mapTitle={this.props.mapData.title}
            stats={this.props.mapData.dataStats}
            helmetComp={helmetComp}
          />
        );
      case "radio-based-chloropleth":
        return (
          <RadioBasedUSChloropleth
            mapData={this.props.mapData}
            mapTitle={this.props.mapData.title}
            stats={this.props.mapData.dataStats}
            helmetComp={helmetComp}
          />
        );
      case "radio-based-chloropleth-with-time-series-data":
        return (
          <RadioBasedUSChloroplethWithTimeSeriesData
            mapData={this.props.mapData}
            mapTitle={this.props.mapData.title}
            stats={this.props.mapData.dataStats}
            helmetComp={helmetComp}
          />
        );
      case "radio-based-chloropleth-with-radio-controls":
        return (
          <RadioBasedUSChloroplethWithRadioControls
            mapData={this.props.mapData}
            mapTitle={this.props.mapData.title}
            stats={this.props.mapData.dataStats}
            helmetComp={helmetComp}
          />
        ); 
      case "world-radio-based-chloropleth":
        return (
          <RadioBasedWorldChloropleth
            mapData={this.props.mapData}
            mapTitle={this.props.mapData.title}
            stats={this.props.mapData.dataStats}
            helmetComp={helmetComp}
          />
        );
      case "radio-based-custom-chloropleth":
        return (
          <RadioBasedCustomMap
            mapData={this.props.mapData}
            mapTitle={this.props.mapData.title}
            stats={this.props.mapData.dataStats}
            helmetComp={helmetComp}
          />
        );
    }

  }
}

export default App;
